@if ({}; as STATE) {
  <section class="advertiser-sub-sector-creation-dialog">
    <advertiser-sub-sector-creation-form [subSector]="subSector()" />
  </section>
}
